import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "EarthFilled"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.4934 6.20375 17.7962 1.50661 12 1.5ZM3.01512 12.2955L4.01862 12.63L5.25012 14.4772V15.4395C5.25016 15.6384 5.32921 15.8291 5.46987 15.9697L7.50012 18V19.7827C4.81342 18.228 3.11815 15.3979 3.01512 12.2955ZM12 21C11.3511 20.9987 10.7044 20.927 10.071 20.7862L10.5 19.5L11.8537 16.116C11.9453 15.8866 11.9181 15.6269 11.781 15.4215L10.7227 13.8337C10.5836 13.6252 10.3494 13.5 10.0987 13.5H6.40122L5.46522 12.0952L7.06047 10.5H8.24997V12H9.74997V9.9495L12.651 4.872L11.349 4.128L10.7077 5.25H8.65122L7.83747 4.02825C10.0482 2.86163 12.6478 2.67897 15 3.525V6C15 6.41421 15.3358 6.75 15.75 6.75H16.8487C17.0994 6.75004 17.3336 6.6248 17.4727 6.41625L18.1305 5.42925C18.9871 6.2282 19.68 7.18627 20.1705 8.25H17.115C16.7576 8.25021 16.45 8.50256 16.38 8.853L15.8377 12.2055C15.785 12.5295 15.9491 12.85 16.2427 12.9967L18.75 14.25L19.2637 17.292C17.5752 19.619 14.875 20.9973 12 21Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/EarthFilled.vue"]]);
